/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
// 字典类数据如何缓存网络请求
import { AxiosRequestConfig } from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { OptionItem } from '@/model/OptionItem';
import { newGatewayUrl } from '@/constant';
import { AreaJsonData } from '@/shared/utils/areaPicker/types';

const getOptionItems = (
  keyword: string,
  config?: AxiosRequestConfig,
): Promise<OptionItem[]> => requestDefault.postGate<OptionItem[]>(
  keyword,
  {},
  {
    baseURL: newGatewayUrl,
    errorRetryDialog: true,
    ...config,
  },
).catch((error) => requestDefault.requestRetryWrapHandler(error));


// 地址列表
export const getAddressList = (): Promise<AreaJsonData> => requestDefault.postGate<AreaJsonData>(
  'f.dict.address.list',
  {},
  {
    baseURL: newGatewayUrl,
    errorRetryDialog: true,
  },
).catch((error) => requestDefault.requestRetryWrapHandler(error));

// 教育级别
export const getEducationLevels = getOptionItems.bind(null, 'f.dict.education.levels');

// 行业类别
export const getIndustryTypes = getOptionItems.bind(null, 'f.dict.industry.types');

// 联系人关系
export const getContactRelations = getOptionItems.bind(null, 'f.dict.query.contactRelations');

// 所属职业
export const getProfessionType = getOptionItems.bind(null, 'f.dict.profession.list', { showLoading: undefined });

// 婚姻状况
export const getMarryTypes = getOptionItems.bind(null, 'f.dict.marry.types');

// 贷款用途
export const getLoanUsage = getOptionItems.bind(null, 'f.dict.query.loan.usages');

// 居住状态
export const getLiveStatus = getOptionItems.bind(null, 'f.dict.query.live.status');

// 工作性质
export const getWorkType = getOptionItems.bind(null, 'f.dict.work.type');

// 收入情况
export const getIncomeType = getOptionItems.bind(null, 'f.dict.income.type');

// 单位性质
export const getCompanyNature = getOptionItems.bind(null, 'f.dict.company.nature');

// 户籍性质
export const getRegistration = getOptionItems.bind(null, 'f.dict.registration.list');

// 职务
export const getPosition = getOptionItems.bind(null, 'f.dict.query.positions');

// 已有负债
export const getDebtSituation = getOptionItems.bind(null, 'f.dict.debt.situation');

// 收入来源
export const getIncomeSource = getOptionItems.bind(null, 'f.dict.income.source');


const DictApi = {
  // 教育级别
  getEducationLevels,
  // 行业类别
  getIndustryTypes,
  // 联系人关系
  getContactRelations,
  // 所属职业
  getProfessionType,
  // 婚姻状况
  getMarryTypes,
  // 地址列表 HTTP REQUEST CACHE http.requestCache
  getAddressList,
  // 贷款用途 HTTP REQUEST CACHE http.requestCache
  getLoanUsage,
  // 居住状态
  getLiveStatus,
  // 工作性质
  getWorkType,
  // 收入情况
  getIncomeType,
  // 单位性质
  getCompanyNature,
  // 户籍性质
  getRegistration,
  getPosition,
  // 已有负债
  getDebtSituation,
  // 收入来源
  getIncomeSource,
};

export default DictApi;
